// English comments only

import axios from "axios";

let refreshPromise = null;

export async function refreshAuthToken() {
  if (refreshPromise) return refreshPromise;

  refreshPromise = (async () => {
    try {
      const res = await axios.post("/api/token/refresh", {}, { withCredentials: true });
      if (res.status === 200) {
        console.info("[Auth] Token refreshed successfully");
        window.dispatchEvent(new CustomEvent("token-refreshed"));
        return true;
      }
      return false;
    } catch (err) {
      console.warn("[Auth] Token refresh failed:", err.message);
      window.dispatchEvent(new CustomEvent("token-refresh-failed"));
      return false;
    } finally {
      setTimeout(() => (refreshPromise = null), 1000);
    }
  })();

  return refreshPromise;
}
